import React from 'react';
import { Box, DialogTitle, Divider, IconButton, Stack, Typography, useMediaQuery } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import fleetIcon from '../../../app/src/components/images/ListAltOutlined.png';

export const CommonDialogTitle = (props) => {
  const { title, handleClose, closeIcon = true, displayBackIcon = false, viewFleetIcon = false, handleInstalledDevices } = props;
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));
  if (isMobile) {
    return (
      <Box sx={{ height: '60px', display: 'flex', alignItems: 'center', backgroundColor: (theme) => theme.palette.background.light2, p: '10px' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
          <Stack direction={'row'} spacing={0.5} pl={displayBackIcon ? 0 : 2}>
            {displayBackIcon && <KeyboardArrowLeftIcon onClick={handleClose} />}
            <Typography variant='h4b' sx={{ alignSelf: 'center' }}>
              {title}
            </Typography>
          </Stack>
          {
            viewFleetIcon && (
              <img 
                src={fleetIcon} 
                alt='fleet'
                style={{
                  padding: '6px',
                  border: '1px solid #F6F6F6',
                  backgroundColor: '#fff',
                  borderRadius: '8px',
                  cursor: 'pointer',
                }}
                onClick={handleInstalledDevices}
              />    
            )
          }
        </Box>
      </Box>
    );
  }

  return (
    <>
      <DialogTitle id='draggable-dialog-title' variant='h4b' sx={{ cursor: 'move', backgroundColor: (theme) => theme.palette.background.light2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box sx={{ display: 'flex', justifyContent: 'left', alignItems: 'center', width: '100%' }}>{title}</Box>
          {
            viewFleetIcon && (
              <img 
                src={fleetIcon} 
                alt='fleet'
                style={{
                  padding: '6px',
                  border: '1px solid #F6F6F6',
                  backgroundColor: '#fff',
                  borderRadius: '8px',
                  cursor: 'pointer',
                }}
                onClick={()=>handleInstalledDevices(true)}
              />    
            )
          }
          {closeIcon && (
            <IconButton
              aria-label='close'
              align='end'
              onClick={handleClose}
              sx={{
                width: '24px',
                height: '24px',
                color: (theme) => theme.palette.grey[500],
                '&:hover': {
                  backgroundColor: (theme) => theme.palette.primary50,
                },
              }}
            >
              <CloseIcon />
            </IconButton>
          )}
        </Box>
      </DialogTitle>
      <Divider />
    </>
  );
};
